module.exports = __webpack_public_path__ + "img/80nan.5c99bdf5.png";